import { render, staticRenderFns } from "./wordDetails.vue?vue&type=template&id=3982c43d&scoped=true"
import script from "./wordDetails.vue?vue&type=script&lang=js"
export * from "./wordDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3982c43d",
  null
  
)

export default component.exports